import { ifPayment } from '../utils/authorization.js';

export default [
    {
        path: '/payments',
        name: 'payments',
        component: () => import(/* webpackChunkName: "payments" */ '../views/Payments/PaymentsList.vue'),
        beforeEnter: ifPayment,
        meta: {
            title: 'payments.paymentsList.pageTitle',
        },
    },
];
